export class WalletError extends Error {}
